import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Translate, withLocalize } from 'react-localize-redux';
import BbCheckbox from "../styling/bbCheckbox";
import classnames from 'classnames';
import { apiPost, getHostApi, processErrorMessage } from '../../store/apiWrapper';
import { isNullOrUndefined, isEmpty } from '../../store/storeFunctions';
import { withRouter } from 'react-router';
import { reportActions } from '../../store/reportStore'
import { BbSelectNoFormik } from '../styling/bbInput';
import Message from '../common/message';
import SanitizedLink from '../common/sanitizedLink';

class CompanyInDifficultySection extends React.Component {
    state = {
        prefillOutput: true,
        lastFinYear: '',
        error: null
    }

    componentDidMount() {
        this.props.setCompanyInDifficultyExportUsed(false);
    }

    section = (sectionId) => {
        return this.props.sections.find(o => o.id === sectionId);
    }

    render() {
        const data = this.section(this.props.sectionId).data;
        if (isNullOrUndefined(data))
            return null;
        return <>
            {this.state.error && <div className="error-container error-container-wide card-special">
                <Message type="warning" options={{ renderInnerHtml: true }}
                    message={this.props.translate(this.state.error.data.error.message, this.state.error.data.error.messageData)}
                />
            </div>}
            <div className="columns is-centered">
                <div className="column" style={{ maxWidth: '900px' }}>

                    <div className='column'><Translate id="Report.CustomizableMsp.OutputCompany" /></div>
                    <div className='column' style={{ paddingTop: '1em' }}>
                        <BbCheckbox name="prefill" id="prefill" label={this.props.translate("Report.CustomizableMsp.PrefillOutput")} value={this.state.prefillOutput} onChange={(v) => { this.setState({ prefillOutput: v }); this.props.setCompanyInDifficultyExportUsed(false); } } />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <div className="column is-half">
                            <Translate id="Report.CustomizableMsp.InsertLastFinDate" />
                        </div>
                        <div className="column is-half">
                            <BbSelectNoFormik options={this.selectValues()} defaultValue='' noOptionsMessage=''
                                onChange={(e) => { this.setState({ lastFinYear: e.value }); this.props.setCompanyInDifficultyExportUsed(false); } }
                            />
                        </div>
                    </div>
                    <div style={{ paddingTop: '1em', width: '100%', textAlign: 'center' }}>
                        <button className={classnames('bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })}
                            onClick={() => this.props.companyInDifficultyExportUsed || !data.available ? undefined : this.downloadOutput()} type="button"
                            disabled={this.props.companyInDifficultyExportUsed || !data.available}>
                            <Translate id='Report.CustomizableMsp.DownloadOutput' />
                        </button>
                    </div>
                    {!data.available && <div className='column'>
                        <Translate id="Report.CustomizableMsp.UseTemplate1" />
                        {isEmpty(data.templateLink) ? <Translate id="Report.CustomizableMsp.OfficialTemplate" />
                            : <SanitizedLink link={data.templateLink} label={this.props.translate("Report.CustomizableMsp.OfficialTemplate")} />
                        }
                        <Translate id="Report.CustomizableMsp.UseTemplate2" />
                    </div>}
                </div>
            </div>
        </>
    }

    selectValues = () => {
        var list = [''];
        for (var i = new Date().getFullYear() - 1; i >= 1992; i--)
            list.push(i);
        return list.map(c => ({ label: c, value: c, key: c }));
    }

    downloadOutput = () => {
        this.props.setCompanyInDifficultyExportUsed(true);
        let mspData = this.props.customizableMspImportData;
        var mspItems = null;
        if (!isNullOrUndefined(mspData) && mspData.hasItems)
            mspItems = mspData.items;
        apiPost(`${getHostApi()}/api/report/${this.props.id}/download-difficulty-output`, null, { prefillOutput: this.state.prefillOutput, lastFinYear: this.state.lastFinYear.toString(), mspItems }, undefined,
            (err) => {
                if (err.data && err.data.error && err.data.error.message)
                    this.setState({ error: err });
                else
                    this.props.raiseSectionError([this.props.sectionId], processErrorMessage(err, "UnhappyUser.SectionError"));
            });
    }
}

export default withLocalize(withRouter(connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(CompanyInDifficultySection)));